import { AdminSession } from './adminSession';

export function hasAdminCredentials(session: AdminSession | null): session is AdminSession {
  return session !== null;
}

export function getAdminAuthHeaders(session: AdminSession): Record<string, string> {
  // OAuth sessions send the JWT via x-api-key so API Gateway CORS preflight succeeds.
  // The action API only allows content-type and x-api-key in Access-Control-Request-Headers.
  if (session.authMethod === 'oauth' && session.accessToken) {
    return {
      'x-api-key': session.accessToken,
    };
  }

  if (session.apiKey) {
    return {
      'x-api-key': session.apiKey,
    };
  }

  return {};
}
